// SchedulePage.jsx

import React from 'react';
import { TaskProvider } from './TaskContext';
import Sidebar from './Sidebar';
import CalendarComponent from './CalendarComponent';
import './SchedulePage.css'
import { useState } from 'react';

const SchedulePage = () => {
    const [filterGroupIds, setFilterGroupIds] = useState([]);

    return (
        <TaskProvider>
            <div className="schedulePage">
                <Sidebar setFilterGroupIds={setFilterGroupIds} />

                <CalendarComponent filterGroupIds={filterGroupIds} />
            </div>
        </TaskProvider>
    );
};

export default SchedulePage;
